<template>
    <SdsMobileHeader
        v-if="isNavbarMobile"
        :isBeingLoaded="isBeingLoaded"
    />
    <SdsGlobalHeader
        v-else
        @pageClick="onPageClick"
        :isBeingLoaded="isBeingLoaded"
    />
</template>

<script>
    import { getConfig } from '@superbet-group/web.lib.config';
    import { MaintenanceType } from '@superbet-group/web.types';
    import {
        mapActions,
        mapGetters,
    } from 'vuex';

    import { isNavbarMobile } from '@app/layout/helpers';
    import SdsMobileHeader from '@app/mobile/navbar/SdsMobileHeader.vue';
    import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
    import SdsGlobalHeader from './components/SdsGlobalHeader.vue';
    import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
    import { PromotionHubEntryEventLabels } from '@src/app/promotionHub/shared/types/PromotionHubEntryLabels';

    export default {
        name: 'HeaderContainer',
        props: {
            isBeingLoaded: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                isBingoEnabled: getConfig().countrySpecific.isBingoEnabled,
            };
        },
        computed: {
            ...mapGetters('navigation', [
                'isOnSportLivePage',
                'isOnSportsPage',
                'isOnPromotionHubPage',
            ]),
            ...mapGetters('data/sportOffer', [
                'isOfferReady',
            ]),
            ...mapGetters('data/maintenance', [
                'isInMaintenance',
            ]),
            ...mapGetters('data/sportOffer', ['liveEventsCount']),
            ...mapGetters('data/authentication', [
                'user',
                'userId',
            ]),
            eventCount() {
                return this.isInMaintenance(MaintenanceType.Live) ? 0 : this.liveEventsCount;
            },
            isNavbarMobile() {
                return isNavbarMobile();
            },
        },
        methods: {
            ...mapActions('ui/modal', [
                'setModal',
            ]),
            ...mapActions('ui/sportOffer/sports', [
                'clearSelectedFeaturedItem',
            ]),
            onPageClick() {
                if (this.isOnPromotionHubPage) {
                    AnalyticsSDK.getInstance().log(
                        'Promo_Hub',
                        {
                            eventAction: 'Entry',
                            eventLabel: PromotionHubEntryEventLabels.topBar,
                            userId: this.userId,
                        },
                    );
                }
                this.clearSelectedFeaturedItem();
            },
            openLoginModal() {
                this.setModal(modalCodes.login);
            },
        },
        components: {
            SdsMobileHeader,
            SdsGlobalHeader,
        },
    };
</script>
